<template>
    <a href="#" @click="logout">
        <i class="pi pi-power-off"></i>
        <h6>Logout</h6>
    </a>
</template>

<script setup>
import { useAuthStore } from '../store';

const auth = useAuthStore();

const logout = async () => {
    console.log('logout requested')
	await auth.logout();
};
</script>
